function showRecoverPasswordForm() {
  document.getElementById('recover-password').style.display = 'block';
  document.getElementById('customer').style.display='none';
}

function hideRecoverPasswordForm() {
  document.getElementById('recover-password').style.display = 'none';
  document.getElementById('customer').style.display = 'block';
}

if (window.location.hash == '#recover') { showRecoverPasswordForm() }

  document.addEventListener("DOMContentLoaded", () => {
    const toggleButtons = document.querySelectorAll(".toggle_form_btns");
    toggleButtons.forEach(btn => {
      btn.addEventListener('click', e => {
        e.target.setAttribute('aria-expanded', (e.target.getAttribute('aria-expanded') === 'false').toString());
      })
    });
    const countrySelects = document.querySelectorAll('[id*="address_country_"]');
    for (const selectElement of countrySelects) {
      const text = selectElement.getAttribute('data-default');
      const foundOption = Array.from(selectElement.options ?? []).find(option => option.innerText == text);
      if (foundOption) {
        selectElement.value = foundOption.value;
      }
    }
  })
  const handleDeleteAddress = async (id) => {
    const result = await confirm(`Are you sure you wish to delete this address`);
    if (result) {
      const formData = new FormData();
      formData.set('_method', 'delete');
      const response = await fetch(`/account/addresses/${id}`, {
        method: "POST",
        body: formData,
      });
      if (response.ok) {
        window.location.reload();
      }
    }
  }
  const handleCancelEditAddress = (id) => {
    const toggleBtn = document.querySelector(`button[aria-controls="edit_address_${id}"]`);
    if (toggleBtn) {
      toggleBtn.setAttribute('aria-expanded', (toggleBtn.getAttribute('aria-expanded') === 'false').toString());
    }
  }
